<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "assetmanagement.edit-general-information.title" | transloco }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'assetmanagement.edit-general-information.instructionText' | transloco
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "assetmanagement.edit-general-information.subTitle" | transloco }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <cerrix-input-group
                [name]="'asset-name'"
                appValidationRequired
                [infoText]="'assetmanagement.edit-general-information.nameInfo' | transloco"
                [value]="editModel.name"
                (valueChange)="editModel.name = $event"
            >
                {{ "assetmanagement.edit-general-information.nameLabel" | transloco }}
            </cerrix-input-group>
            <cerrix-textarea-group
                [name]="'asset-description'"
                [textareaDialogTitle]="
                    'assetmanagement.edit-general-information.descriptionLabel' | transloco
                "
                [infoText]="'assetmanagement.edit-general-information.descriptionInfo' | transloco"
                [rows]="5"
                [placeholder]="
                    'assetmanagement.edit-general-information.descriptionPlaceholder' | transloco
                "
                [value]="editModel.description"
                (valueChange)="editModel.description = $event"
            >
                {{ "assetmanagement.edit-general-information.descriptionLabel" | transloco }}
            </cerrix-textarea-group>
            @if (optionsLoaded && showThirdPartySelection) {
                <app-cerrix-select-group
                    name="asset-third-party"
                    [infoText]="
                        'assetmanagement.edit-general-information.thirdPartyInfo' | transloco
                    "
                    [options]="thirdPartyOptions"
                    [selectedValue]="editModel?.thirdPartyId"
                    (selectionChange)="onThirdPartyChange($event)"
                >
                    {{ "assetmanagement.edit-general-information.thirdPartyLabel" | transloco }}
                </app-cerrix-select-group>
                <app-cerrix-select-group
                    name="asset-contract"
                    [options]="contractOptions"
                    [infoText]="'assetmanagement.edit-general-information.contractInfo' | transloco"
                    [selectedValue]="editModel?.contractId"
                    [disabled]="isContractDisabled"
                    (selectionChange)="onContractChange($event)"
                >
                    {{ "assetmanagement.edit-general-information.contractLabel" | transloco }}
                </app-cerrix-select-group>
            }
            @if (optionsLoaded && !showThirdPartySelection) {
                <span class="no-rights-text">
                    {{
                        "assetmanagement.edit-general-information.noThirdPartyRightsText"
                            | transloco
                    }}
                </span>
            }
        </div>
    }
</div>

<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="openUnsavedChangesConfirmDialog()"
    >
        {{ "assetmanagement.detail.cancelButton" | transloco }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="editSave()"
    >
        {{ "assetmanagement.detail.editSaveButton" | transloco }}
    </cerrix-button>
</div>

<cerrix-confirm-dialog
    [name]="confirmUnsavedChangesDialogName"
    dataUiid="asset-management-edit-unsaved-changes-confirm"
    icon="warning"
    [title]="'assetmanagement.edit-general-information.unsavedChangesDialogTitle' | transloco"
    [description]="
        'assetmanagement.edit-general-information.unsavedChangesDialogDescription' | transloco
    "
    [cancelText]="
        'assetmanagement.edit-general-information.unsavedChangesDialogCancelText' | transloco
    "
    [confirmText]="
        'assetmanagement.edit-general-information.unsavedChangesDialogConfirmText' | transloco
    "
    (cancel)="editCancel()"
    (confirm)="editSave()"
    [waitingOnResult]="editSaving"
    [showResultText]="editSaving"
    class="dialog-unsaved-changes-confirm"
>
</cerrix-confirm-dialog>
